import { render } from "./HeroImage.vue?vue&type=template&id=4a80af22&scoped=true"
import script from "./HeroImage.vue?vue&type=script&lang=js"
export * from "./HeroImage.vue?vue&type=script&lang=js"

import "./HeroImage.vue?vue&type=style&index=0&id=4a80af22&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a80af22"]])

export default __exports__